import Loader from "components/shared/loader";
import { paths } from "helpers/paths";
import { useRouter } from "hooks/useRouter";
import React, { useState } from "react";
import { alert } from "services/alert";
import { forgotPassword } from "sources/account";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [success, setSuccess] = useState<boolean | undefined>();
    const [loading, setLoading] = useState(false);
    const submitForm = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoading(true);
        forgotPassword({ email }).then((res) => {
            setLoading(false);
            if (res) {
                setSuccess(true);
            } else {
                alert({ type: "error", message: "При восстановлении пароля произошла ошибка", title: "Ошибка" });
            }
        });
    };

    const router = useRouter();
    return (
        <div className="no-overflow h-100">
            <div className="identity-container">
                {loading && (
                    <div className="loader-snippet--disable-loader">
                        <Loader />
                    </div>
                )}
                <div className="identity-container__shadow" />
                <div className="identity-container__background" />
                <div className="identity-panel identity-panel--small">
                    <div className="identity-column">
                        <h1 className="identity-container__title" />
                        <div className="identity-column__title">Восстановление пароля</div>
                        {success ? (
                            <div className="col-12 text-center">
                                Ссылка для сброса пароля
                                <br />
                                отправлена на почту
                            </div>
                        ) : (
                            <form className="identity-form" onSubmit={submitForm}>
                                <div className="identity-field">
                                    <div className="col-12">
                                        <input
                                            required
                                            className="form-control"
                                            type="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            placeholder="Введите почту"
                                        />
                                    </div>
                                </div>
                                <div className="identity-form__legal identity-form__legal--before-action col-12">
                                    Нажимая кнопку «Восстановить доступ», вы подтверждаете, что ознакомлены с{" "}
                                    <a href="https://cargorun.ru/privacy" target="_blank" rel="noreferrer">
                                        Политикой обработки персональных данных
                                    </a>{" "}
                                    и соглашаетесь на обработку указанного e-mail в целях восстановления доступа к
                                    аккаунту.
                                </div>
                                <div className="identity-field col-12">
                                    <button
                                        className="identity-form__button identity-form__button--yellow identity-form__button--text-small"
                                        type="submit"
                                    >
                                        Получить ссылку для восстановления
                                    </button>
                                </div>
                                <div className="identity-form__button-group col-12">
                                    <a
                                        className="identity-form__link identity-form__link--centered cursor-pointer"
                                        onClick={() => router.push(paths.login)}
                                    >
                                        Вспомнили пароль?
                                    </a>
                                </div>
                            </form>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
